import { render, staticRenderFns } from "./HorizontalResizer.vue?vue&type=template&id=415ef37b&scoped=true&"
import script from "./HorizontalResizer.vue?vue&type=script&lang=js&"
export * from "./HorizontalResizer.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalResizer.vue?vue&type=style&index=0&id=415ef37b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415ef37b",
  null
  
)

export default component.exports